import React from 'react';
import Box from '../Box/Box';
import Icon from '../Icon/Icon';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import { TButtonIcons } from './types/TButtons';
import { TIcon } from '../../types/TStyleVariables';

type ButtonIconProps = TButtonIcons & {
  name: TIcon;
  /** @deprecated start icon is the default and only supported modifier */
  isEndIcon?: boolean;
  /** @deprecated only button with start icon is supported */
  isStartIcon?: boolean;
};
//TODO: Remove isStartIcon and isEndIcon props
const ButtonIcon: React.FC<ButtonIconProps> = ({ name, isEndIcon = false, isStartIcon = true, ...rest }) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: [isStartIcon && 'start', isEndIcon && 'end'],
  });
  return (
    <Box {...rest} {...conditionalProps} parent="Button" name="Icon" as="span">
      <Icon name={name} />
    </Box>
  );
};

export default React.memo(ButtonIcon);
